<template>
  <v-app>
    <header>
      <router-link to="/" class="logo">
        <img alt="Monad Logo" src="@/assets/logo.png" />
      </router-link>
      <Nav />
      <User />
    </header>
    
    <main>
      <div class="content">
        <!-- Vue Router 4 / 5 standard fallback route insertion slot -->
        <router-view />
      </div>
      <Messages />
    </main>
  </v-app>
</template>

<script>
import Messages from "@/components/Messages.vue";
import Nav from "@/components/Nav.vue";
import User from "@/components/User.vue";

// 👈 Fixed: Swapped standard require() assignments for ES Module imports
import "vue-good-table-next/dist/vue-good-table-next.css";
import "@/assets/app.css";

export default {
  name: "App",
  components: { Messages, Nav, User }
};
</script>
